<div class="coworking-bank-info">
  <h3>{{ "coworking.bank-info.add" | translate }}</h3>
  <p>{{ "coworking.bank-info.message" | translate }}</p>
  <h3>{{ "coworking.bank-info.account" | translate }}</h3>
  <div [formGroup]="form">
    <div class="inline">
      <cowing-input
        [inputStyle]="EInputStyleType.Secondary"
        [isForm]="true"
        [placeholder]="'coworking.bank-info.holder' | translate"
        [control]="form.get('holderId')"
      ></cowing-input>
      <cowing-input
        [inputStyle]="EInputStyleType.Secondary"
        [isForm]="true"
        [placeholder]="'coworking.bank-info.swift' | translate"
        [control]="form.get('swift')"
      ></cowing-input>
      <cowing-input
        [inputStyle]="EInputStyleType.Secondary"
        [isForm]="true"
        [placeholder]="'coworking.bank-info.iban' | translate"
        [control]="form.get('IBAN')"
      ></cowing-input>
    </div>
    <h3>{{ "coworking.bank-info.address" | translate }}</h3>
    <div class="address">
      <cowing-input-location
        [inputStyle]="EInputStyleType.Secondary"
        [isForm]="true"
        [placeholder]="'coworking.bank-info.bank-address' | translate"
        [control]="form.get('bankAddress')"
        (setLocation)="setLocation($event)"
      ></cowing-input-location>
    </div>
  </div>
  <span *ngIf="isEditingInfo">
    {{ "coworking.bank-info.disclaimer-bank-info" | translate }}</span
  >
  <div *ngIf="isEditingInfo" class="actions-footer">
    <cowing-button
      [label]="'general.close' | translate"
      [type]="EButtonType.RoundedSecondary"
      [iconShow]="false"
      (event)="goBack()"
    >
    </cowing-button>
  </div>
</div>
